export default "__VITE_ASSET__BfFoUvew__"